<template>
    <page>
        <div class="shadow-25" v-if="mockData">
            <v-header :title="$metaInfo.title" icon="note add">
                <template slot="right">
                    <v-button flat rounded dense color="primary"
                              icon="list"
                              :label="$T('go to list')"
                              @click="$router.push({name: 'call-center.orders'})">
                    </v-button>
                </template>
            </v-header>
            <card width="100%">

                <form class="row gutter-xs"
                      @keydown="form.onKeydown($event)">

                    <v-input path="firstname"
                             v-model="form.firstname"
                             :label="$t('first name')"
                             :form="form"
                             class="col-md-4 col-sm-6 col-xs-12">
                    </v-input>

                    <v-input path="lastname"
                             v-model="form.lastname"
                             :label="$t('last name')"
                             :form="form"
                             class="col-md-4 col-sm-6 col-xs-12">
                    </v-input>

                    <v-input path="phone"
                             v-model="form.phone"
                             :label="$t('cell phone')"
                             :form="form"
                             class="col-md-4 col-sm-6 col-xs-12">
                    </v-input>

                    <v-input path="email"
                             v-model="form.email"
                             :label="$t('email')"
                             optional
                             :form="form"
                             class="col-md-4 col-sm-6 col-xs-12">
                    </v-input>

                    <v-display v-model="startLendingAt"
                               :label="$t('lending start date')"
                               :form="form"
                               class="col-md-4 col-sm-6 col-xs-12">
                    </v-display>

                    <v-display v-model="endLendingAt"
                               :label="$t('lending end date')"
                               :form="form"
                               class="col-md-4 col-sm-6 col-xs-12">
                    </v-display>

                    <v-select path="origin_id"
                              auto-select
                              v-model="form.origin_id"
                              :label="$t('contact coming from')"
                              optional
                              :item-plural="$t('origins')"
                              :options="mockData.origins"
                              :form="form"
                              class="col-md-4 col-sm-6 col-xs-12">
                    </v-select>

                    <v-select path="follow_up"
                              auto-select
                              v-model="form.follow_up"
                              :label="$t('follow up')"
                              :helper="$t('the consumer wants to receive commercial communications (including email or equivalent electronic means of communication) to keep abreast of IQOS news, and news about products and services that will help me make the most of my experience with IQOS.')"
                              :item-plural="$t('options')"
                              :options="followUpOptions"
                              :form="form"
                              class="col-md-4 col-sm-6 col-xs-12">
                    </v-select>

                    <v-input path="observations"
                             v-model="form.observations"
                             :label="$t('observations')"
                             optional
                             :form="form"
                             type="textarea"
                             class="col-12">
                    </v-input>

                    <!-- <v-radio-buttons path="delivery"
                                     v-model="form.delivery"
                                     :label="$t('delivery option')"
                                     :options="deliveryOptions"
                                     :form="form"
                                     class="col-12"
                                     @input="mayClearAddressAndLendingPoint">
                    </v-radio-buttons> -->

                    <!-- <q-slide-transition>
                        <div class="col-12" v-if="form.delivery == 1">
                            <div class="row gutter-xs">
                                <v-autocomplete-list path="lending_point_id"
                                                     auto-select
                                                     v-model="form.lending_point_id"
                                                     :label="$t('courier')"
                                                     :item-plural="$t('couriers')"
                                                     :options="couriers"
                                                     :form="form"
                                                     class="col-12">
                                </v-autocomplete-list>

                                <v-input path="address"
                                         v-model="form.address"
                                         :label="$t('address')"
                                         :form="form"
                                         class="col-md-6 col-xs-12">
                                </v-input>

                                <v-input path="address_2"
                                         v-model="form.address_2"
                                         :label="$t('address 2')"
                                         :form="form"
                                         class="col-md-6 col-xs-12">
                                </v-input>

                                <v-input path="zipcode"
                                         v-model="form.zipcode"
                                         :label="$t('zip code')"
                                         :form="form"
                                         class="col-md-6 col-xs-12">
                                </v-input>

                                <v-input path="city"
                                         v-model="form.city"
                                         :label="$t('city')"
                                         :form="form"
                                         class="col-md-6 col-xs-12">
                                </v-input>

                            </div>
                        </div>
                    </q-slide-transition> -->
                    <v-display class="col-12"
                                path="lending_point_id"
                                v-model="form.lending_kit_id"
                                :form="form">
                        <div class="col-12">
                            <div class="row gutter-sm">

                                <div class="col-8">
                                    <div tabindex="-1"
                                            class="q-if row no-wrap relative-position q-input q-if-standard q-if-has-content text-highlight">
                                        <div class="q-if-baseline">|</div>
                                        <div class="q-if-inner col column">
                                            <div class="row no-wrap relative-position"><span
                                                    class="q-if-addon q-if-addon-left q-if-addon-visible">{{ $T('search') }}:&nbsp;</span>
                                                <gmap-autocomplete value="España"
                                                                    class="col q-input-target q-no-input-spinner ellipsis"
                                                                    @place_changed="setPlace"/>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-4">
                                    <v-input path="filterKey"
                                                v-model="filterKey"
                                                :prefix="`${$T('filter')}:&nbsp;`"
                                                :form="form">
                                    </v-input>
                                </div>

                                <div class="col-8">

                                    <GmapMap :center="mapCenter"
                                                :zoom="mapZoom"
                                                map-type-id="roadmap"
                                                style="width: 100%; height: 400px">
                                        <gmap-marker v-for="(lendingPoint, i) in lendingPointsWithStock"
                                                        :key="i"
                                                        :position="lendingPoint.coords"
                                                        :clickable="true"
                                                        @click="select(lendingPoint)"
                                        ></gmap-marker>
                                    </GmapMap>

                                </div>
                                <div class="col-4">

                                    <q-scroll-area style="width: 100%; height: 400px; border: 1px solid #ddd">
                                        <q-list inset-separator no-border link>
                                            <q-item v-for="(lendingPoint, i) in filteredLendingPoints"
                                                    :key="i" multiline
                                                    @click.native="select(lendingPoint)">
                                                <q-item-side
                                                        :icon="isSelected(lendingPoint) ? 'check circle' : 'place'"
                                                        inverted
                                                        :color="isSelected(lendingPoint) ? 'highlight' : 'primary'"/>
                                                <q-item-main>
                                                    <q-item-tile label>{{ lendingPoint.description }}</q-item-tile>
                                                    <q-item-tile sublabel>
                                                        {{ lendingPoint.address }},
                                                        {{ lendingPoint.address_2 }} -
                                                        {{ lendingPoint.city }},
                                                        {{ lendingPoint.zipcode }}
                                                    </q-item-tile>
                                                </q-item-main>
                                                <q-item-side right
                                                                :stamp="`${unitsFrom(lendingPoint)} ${$T('un.')}`"/>
                                            </q-item>
                                        </q-list>
                                    </q-scroll-area>

                                </div>
                            </div>
                        </div>
                    </v-display>

                    <!-- Submit Button -->
                    <div class="col-12 row justify-center q-mt-md">
                        <v-button outline
                                  :label="$T('save')"
                                  icon="save"
                                  color="highlight"
                                  class="no-shadow uppercase q-btn-iqos"
                                  :loading="form.busy"
                                  @click="onSubmit">
                            <template slot="loading">
                                <q-spinner-puff class="on-left" color="white"></q-spinner-puff>
                                {{ $T('saving...') | capitalize }}
                            </template>
                        </v-button>
                    </div>

                </form>

            </card>

        </div>
        <div class="row justify-center items-center row-spinner-height" v-else>
            <spinner-iqos size="60px"/>
        </div>
    </page>
</template>

<script>
    import Form from 'vform'
    import moment from 'moment'
    import axios from 'axios'
    import {
        QScrollArea,
        QList,
        QListHeader,
        QItem,
        QItemMain,
        QItemSeparator,
        QItemSide,
        QItemTile,
        QSpinnerPuff,
        QSlideTransition
    } from 'quasar-framework'
    import orderModel from '../orderModel'

    export default {
        middleware: 'auth',

        mixins: [orderModel],

        metaInfo() {
            return {title: this.$T('create a new reservation')}
        },

        components: {
            QScrollArea,
            QList,
            QListHeader,
            QItem,
            QItemMain,
            QItemSeparator,
            QItemSide,
            QItemTile,
            QSpinnerPuff,
            QSlideTransition
        },

        data() {
            return {
                mockData: null,
                mapZoom: 6,
                mapCenter: {
                    lat: 40.4378698,
                    lng: -3.8196193
                },
                filterKey: '',
                form: new Form(orderModel.data().orderModel),
                deliveryOptions: [
                    {value: 1, label: this.$T('address'), icon: 'home'},
                    {value: 0, label: this.$T('lending point'), icon: 'store'}
                ],
                followUpOptions: [
                    {value: 1, label: this.$T('yes')},
                    {value: 0, label: this.$T('no')}
                ]
            }
        },

        computed: {
            startLendingAt() {
                return moment().format('DD-MM-YYYY')
            },

            endLendingAt() {
                return moment().add(this.mockData.lendingDays, 'days').format('DD-MM-YYYY')
            },

            filteredLendingPoints() {
                let filterKey = this.filterKey && this.filterKey.toLowerCase()
                let data = this.lendingPointsWithStock
                if (filterKey) {
                    data = data.filter(row => Object.keys(row)
                        .some(key => String(row[key]).toLowerCase().indexOf(filterKey) > -1))
                }
                return data
            },

            lendingPointsWithStock() {
                return this.mockData['lendingPoints'].filter(item => this.unitsFrom(item) > 0)
            },

            couriers() {
                return this.mockData.couriers.filter(item => this.unitsFrom(item) > 0)
                    .map(item => ({
                        label: `${item.description}`,
                        value: item.id,
                        sublabel: `${this.$T('stock')}: ${this.unitsFrom(item)}`
                    }))
            }
        },

        methods: {
            /**
             * Loads the "mock data" from the store
             */
            async getMockData() {
                const {data} = await axios.get(`${config.appUrl}/api/v1/call-center/order/form-mock-data`)
                this.mockData = data.data
            },

            isSelected(lendingPoint) {
                return this.form.lending_point_id == lendingPoint.id
            },

            select(lendingPoint) {
                if (this.form.lending_point_id == lendingPoint.id) {
                    this.form.lending_point_id = null
                    return
                }
                this.form.lending_point_id = lendingPoint.id
                this.mapCenter = lendingPoint.coords
                this.mapZoom = 16
            },

            unitsFrom(lendingPoint) {
                let kitsAvailable = lendingPoint.kits_available ? lendingPoint.kits_available.count : 0
                let reservations = lendingPoint.reservations ? lendingPoint.reservations.count : 0
                return kitsAvailable - reservations
            },

            setPlace(place) {
                if (place && place.geometry) {
                    this.mapCenter = {
                        lat: place.geometry.location.lat(),
                        lng: place.geometry.location.lng()
                    }
                    this.mapZoom = 13
                }
            },

            mayClearAddressAndLendingPoint(isDelivery) {
                if (!isDelivery) {
                    this.form.address = ''
                    this.form.address_2 = ''
                    this.form.city = ''
                    this.form.zipcode = ''
                }
                this.form.lending_point_id = null
            },

            async onSubmit() {
                let response = await this.form.post(`/api/v1/call-center/order`)
                if (!response.data) return
                this.getMockData()
                let { data } = response
                this.form = new Form(this.orderModel)
                this.$q.dialog({
                    title: this.$T('success'),
                    message: data.success.message,
                    preventClose: true,
                    stackButtons: false,
                    ok: {
                        label: this.$T('go to list'),
                        outline: true,
                        rounded: true,
                        color: 'primary',
                        noCaps: true
                    },
                    cancel: {
                        color: 'highlight',
                        label: `${this.$T('new')} ${this.$t('order')}`,
                        rounded: true,
                        textColor: 'primary',
                        noCaps: true
                    }
                }).then(() => {
                    this.$router.push({name: 'call-center.orders'})
                }).catch(() => {
                })
            }
        },

        mounted() {
            this.getMockData()
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/remote-coach/order.vue